export const orderData = [
  {
    "itmId": "SKU1234561",
    "itmSku": "SKU123456",
    "prdNameAndAttributes": "Rad Name",
    "availUnit": "0",
    "type": "Parcel"

  },
  {
    "itmId": "SKU1234562",
    "itmSku": "SKU123456",
    "prdNameAndAttributes": "No Name",
    "availUnit": "500",
    "type": "Parcel"
  },
  {
    "itmId": "SKU1234563",
    "itmSku": "SKU123456",
    "prdNameAndAttributes": "Queue Name",
    "availUnit": "68",
    "type": "Parcel"
  }
]


// WEBPACK FOOTER //
// ./src/stores/orderDataExample.js